import { render, staticRenderFns } from "./deanInputSwitch.vue?vue&type=template&id=35e83d02&scoped=true"
import script from "./deanInputSwitch.vue?vue&type=script&lang=ts"
export * from "./deanInputSwitch.vue?vue&type=script&lang=ts"
import style0 from "./deanInputSwitch.vue?vue&type=style&index=0&id=35e83d02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e83d02",
  null
  
)

export default component.exports